var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-box",class:[_vm.sType, { 'd-flex f-justify-center': _vm.center, 'absolute': _vm.absolute }]},[(_vm.type === 'img')?_c('img',{attrs:{"alt":_vm.alt,"src":_vm.src}}):_c('span',{class:{ 'contain': _vm.contain, 'bottom': _vm.bottom },style:(("background-image: url('" + _vm.src + "')"))})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79e7b677","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stories/image/index.vue
// module id = null
// module chunks = 